import queryString from 'query-string'

export default string => {
    return queryString.parse(string, {})
}
